import { Day } from '../ts/@types/generated/graphql/catalog-service/graphql';
import { DateTime } from 'luxon';
import { computeEstimatedDeliveryDate } from './compute-estimated-delivery-date';

export const mapProgramDeliveriesToUpcomingDeliveryDates = (
  deliveryWeekdays: Day[],
  upcomingDeliveryDates: string[],
  estimatedTransitTime?: number | null,
) => {
  return deliveryWeekdays.map((weekday) => {
    const date = upcomingDeliveryDates.find((upcomingDeliveryDate) => {
      const upcomingDeliveryDateAsDateTime = DateTime.fromISO(
        upcomingDeliveryDate,
        { zone: 'utc' },
      );
      return upcomingDeliveryDateAsDateTime.weekdayLong === weekday;
    });
    if (!date) {
      throw new Error('Failed to map delivery day to upcoming delivery date');
    }

    const estimatedDeliveryDate =
      estimatedTransitTime === null || estimatedTransitTime === undefined
        ? undefined
        : computeEstimatedDeliveryDate(date, estimatedTransitTime);

    return {
      deliveryDate: date,
      estimatedDeliveryDate,
    };
  });
};
